import { useSelector } from "react-redux";
import { Card, Select } from "@radix-ui/themes";

function DevSelectorComponent({ containers, currentContainer, setCurrentContainer }) {
  const isInventoryOpen = useSelector(({ inventory }) => inventory.isOpen);
  const handleSelectChange = (value: string) => {
    setCurrentContainer(value);
  };

  if (isInventoryOpen) return null;

  return (
    <Card className="fixed top-20 right-10 p-5 w-[15rem]">
      <Select.Root value={currentContainer} required onValueChange={handleSelectChange}>
        <Select.Trigger className="w-full" />

        <Select.Content position="popper" align="end">
          <Select.Item value={null}>Выбери режим</Select.Item>

          {containers.map((containerName: string) => (
            <Select.Item key={containerName} value={containerName}>
              {containerName}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>
    </Card>
  );
}

export default DevSelectorComponent;
